import * as React from 'react'
import { NavigationTabs, NavigationTabsButton } from '@components/navigation-tabs'
import { ScrollableModalTab, useModalWithScrollableTabs } from '@components/hooks/use-modal-with-scrollable-tabs'

type Tab = 'data' | 'history' | 'codes'

interface Props {
  dataRef: React.RefObject<HTMLElement>
  historyRef: React.RefObject<HTMLElement>
  codesRef: React.RefObject<HTMLDivElement>
}

export const CafeteriaDetailsTabs: React.FC<Props> = ({ dataRef, historyRef, codesRef }) => {
  const [tab, setTab] = React.useState<Tab>('data')

  const tabs: ScrollableModalTab<Tab>[] = [
    { ref: dataRef, name: 'data' },
    { ref: codesRef, name: 'codes' },
    { ref: historyRef, name: 'history' },
  ]

  const { handleTabClick } = useModalWithScrollableTabs<Tab>({ modalId: 'cafeteria-modal', setTab, tabs })

  const buttons: NavigationTabsButton[] = [
    {
      title: 'Dane podstawowe',
      isActive: tab == 'data',
      onClick: handleTabClick('data'),
    },
    {
      title: 'Lista kodów',
      isActive: tab == 'codes',
      onClick: handleTabClick('codes'),
    },
    {
      title: 'Historie',
      isActive: tab == 'history',
      onClick: handleTabClick('history'),
    },
  ]

  return <NavigationTabs buttons={buttons} />
}
